import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getUserList = (params) => AxiosClient.get('/user', params);
const UserCreate = payload => AxiosClient.post('/user', payload);
const userUpdate = (params, payload) => AxiosClient.put(`/user/${params}`, payload);
const UserDelete = params => AxiosClient.delete(`/user/${params}`);
const UserDeactivate = params => AxiosClient.put(`/deactivate/${params}`);
const getUserDetails = params => AxiosClient.get(`/user/${params}`);
const getCsvMappingField = payload => AxiosClient.post('/get-csv-mapping-fields', payload)
const csvUpload = payload => AxiosClient.post('/csv-upload', payload)
const sendResetPasswordLink = (payload) => AxiosClient.post('/forget/password', payload);
const validationForToken = (payload) => AxiosClient.post('/validate-token', payload);
const CsvTemplateDownload = (payload) => AxiosClient.post('/download-csv', payload);
const resendToken = (payload) => AxiosClient.post('/password/token/reset', payload);
const userProfileUpdate = (params, payload) => AxiosClient.put(`/user-profile/${params}`, payload);
const userProfilePictureUpdate = (params, payload) => AxiosClient.put(`/user-profile-picture/${params}`, payload);
const userProfilePictureRemove = (params) => AxiosClient.put(`/user-profile-remove/${params}`);

export {
    getUserList,
    UserCreate,
    userUpdate,
    UserDelete,
    UserDeactivate,
    csvUpload,
    getUserDetails,
    getCsvMappingField,
    sendResetPasswordLink,
    validationForToken,
    CsvTemplateDownload,
    resendToken,
    userProfileUpdate,
    userProfilePictureUpdate,
    userProfilePictureRemove
}